import Backbone from "backbone";
import { pathname } from "../../common/others/Configuration";
import $ from "jquery";
import SharedDispatcher from "../../common/others/SharedDispatcher";
import { MagnificPopup } from "../../common/dynamic-imports/MagnificPopup";

export default Backbone.View.extend({

  initialize: function () {
    this.cancelPopin = this.cancelPopin.bind(this);
    this.magnificPopup = new MagnificPopup();
    this.initializePopup();
  },

  events: {
    "click .js-closePopin": "cancelPopin",
    "click .js-removeCard": "removeCard",
    "click .js-removePaymentMethod": "removePaymentMethod"
  },

  initializePopup: function () {
    const self = this;
    this.magnificPopup.open({
      items: {
        src: self.el,
        type: "inline"
      },
      fixedContentPos: true,
      mainClass: "f-mfp"
    });
  },

  cancelPopin: function (e) {
    e.preventDefault();
    this.magnificPopup.close();
  },

  removeCard: function (e) {
    const ref = $(e.currentTarget).data("ref");
    $.ajax({
      type: "POST",
      // TODO move to account configuration (as template URL)
      url: pathname + "/account/api/v1/creditcard/delete/" + ref,
      success: function () {
        if ($(".js-removeCCcontainer").length === 0) {
          location.reload();
        }

        $.magnificPopup.close();
        SharedDispatcher.trigger("paymentMethodContainer:remove", ref);
      },
      error: function () {
        self.magnificPopup.close();
        SharedDispatcher.trigger("flashmessage:show");
      }
    });
  },

  removePaymentMethod: function (e) {
    const self = this;
    const ref = $(e.currentTarget).data("ref");

    $.ajax({
      type: "POST",
      // TODO move to account configuration (as template URL)
      url: pathname + "/account/api/v1/creditcard/unlink-partner/" + ref,
      success: function () {
        self.magnificPopup.close();
        SharedDispatcher.trigger("paymentMethodContainer:remove", ref);
      },
      error: function () {
        self.magnificPopup.close();
        SharedDispatcher.trigger("flashmessage:show");
      }
    });
  }
});
